import { type ReactNode } from 'react';
import clsx from 'clsx';
import styles from './Highlight.module.css';

type Props = {
  children: ReactNode;
  className?: string;
};

export function Highlight({ className, children }: Props) {
  return <span className={clsx(styles.rect, className)}>{children}</span>;
}
